<template>
  <div>
    <blade-hero
      :content="mainHero"
      btnMain="white"
      btnSecondary="white-alpha"
    ></blade-hero>
    <blade-hero
      :content="secondaryBlade"
      alignment="right"
      btnMain="white"
      btnSecondary="black-two"
    ></blade-hero>
    <blade-hero
      :content="tertiaryBlade"
      btnMain="white"
      btnSecondary="white-alpha"
    ></blade-hero>
  </div>
</template>

<script>
// @ is an alias to /src
import BladeHero from "@/components/blade-hero";

export default {
  name: "Home",
  components: { BladeHero },
  computed: {
    mainHero() {
      return this.$store.state.homePage.mainBlade;
    },
    secondaryBlade() {
      return this.$store.state.homePage.secondaryBlade;
    },
    tertiaryBlade() {
      return this.$store.state.homePage.tertiaryBlade;
    },
  },
  methods: {},
};
</script>

<style lang="scss">
video {
  width: 100%;
}
</style>
